import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {actionCreator} from '../store';
import './codeSet.less';
import {Form, Row, Col, Input, Button, Select, Table, Popconfirm} from 'antd';
import {DataCodesetPageList, GetDataCodesetSelects, GetDataCodesetDel} from '../../../services/config/ConfigService'
import {createFromIconfontCN} from "@ant-design/icons";
import { updateMenuModule } from '../../../utils/storage';

const FormItem = Form.Item;
const {Option} = Select;
const IconFont = createFromIconfontCN({
    scriptUrl: [
        '//at.alicdn.com/t/font_2343612_7unhssk7d2o.js',
    ],
});

class codeSet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 1, // 当前页码数
            codeSetList: [], // 编码集数据集合
            stateSelectList: [], // 编码集 状态 下拉集合
            typeSelectList: [], // 编码集 类型 下拉集合
            state: 'USE', // 编码集 状态 默认值
            useScopeSelectList: [], // 编码集 使用范围 下拉集合
            pagination: { // 分页组件元素对象信息
                onChange: (pageNo) => {
                    this.getList(pageNo);
                },
                current: 1,
                pageSize: 10,
                total: 1,
                showSizeChanger: false,
            },
            columns: [
                {
                    align: 'center',
                    title: '数据集名称',
                    key: 'name',
                    width: 120,
                    dataIndex: 'name'
                },
                {
                    align: 'center',
                    title: '数据集编码',
                    key: 'code',
                    width: 120,
                    dataIndex: 'code'
                },
                {
                    align: 'center',
                    title: '使用范围',
                    key: 'useScopeName',
                    width: 120,
                    dataIndex: 'useScopeName'
                },
                {
                    align: 'center',
                    title: '类型',
                    key: 'typeName',
                    width: 120,
                    dataIndex: 'typeName'
                },
                {
                    align: 'center',
                    title: '状态',
                    key: 'stateName',
                    width: 120,
                    dataIndex: 'stateName'
                },
                {
                    align: 'center',
                    title: '创建时间',
                    key: 'createTime',
                    width: 180,
                    dataIndex: 'createTime'
                },
                {
                    align: 'center',
                    title: '创建人',
                    key: 'createUser',
                    width: 220,
                    dataIndex: 'createUser',
                    render: (text, item) => {
                        return <div>
                            ({item.createUser}) {item.createUserName}
                        </div>
                    }
                },
                {
                    align: 'center',
                    title: '操作',
                    width: 140,
                    fixed: 'right',
                    render: (text, item) => {
                        return (
                            <div className={'tableBtns'}>
                                <div onClick={() => {
                                    this.handleItemDetail(item)
                                }}>
                                    {this.formatIcon('iconchakan')}
                                    查看
                                </div>
                                <div onClick={() => {
                                    this.handleItemEdit(item)
                                }}>
                                    {this.formatIcon('iconbianji')}
                                    编辑
                                </div>
                                <Popconfirm
                                    title="确认删除该条数据?"
                                    okText='确认'
                                    cancelText='取消'
                                    onConfirm={() => {
                                        this.handleItemDelete(item)
                                    }}
                                >
                                    <div className={'del'}>
                                        {this.formatIcon('iconshanchu')}
                                        删除
                                    </div>
                                </Popconfirm>
                            </div>
                        )
                    }
                }
            ],// 表格配置
            tableLoading: false, // 表格 loading
        };
    }

    formRef = React.createRef();

    componentDidMount() {
        this.getList();
        this.getDataCodesetSelects()
    }

    /**
     * icon 图标
     */
    formatIcon = iconName => {
        return iconName ? (<IconFont type={iconName}/>) : undefined;
    }

    /**
     * 获取 编码集查询list
     */
    getList = (currentPage) => {
        this.setState({
            tableLoading: true
        })
        let {
            name,
            state,
            type,
            createUser,
            useProject,
            useScope
        } = this.formRef.current.getFieldsValue(['name', 'state', 'type', 'createUser', 'useProject', 'useScope'])
        const params = {
            name: name ? name : null,
            state: state ? state : null,
            type: type ? type : null,
            createUser: createUser ? createUser : null,
            useProject: useProject ? useProject : null,
            useScope: useScope ? useScope : null,
            page: currentPage ? currentPage : this.state.page,
            pageSize: this.state.pagination.pageSize,
        }
        DataCodesetPageList(params).then(res => {
            if (res) {
                this.setState({
                    tableLoading: false,
                    codeSetList: res.rows,
                    page: res.page,
                    pagination: {
                        ...this.state.pagination,
                        current: res.page,
                        pageSize: res.pageSize,
                        total: res.total,
                    }
                })
            } else {
                this.setState({
                    tableLoading: false
                })
            }
        })
    }

    /**
     * 获取 编码集 下拉框集合
     */
    getDataCodesetSelects = () => {
        GetDataCodesetSelects().then(res => {
            if (res) {
                this.setState({
                    stateSelectList: res.stateEnumList,
                    typeSelectList: res.typeEnumList,
                    useScopeSelectList: res.useScopeEnumList,
                }, () => {
                    this.props.handleCodesetSelectList(res.stateEnumList, res.typeEnumList, res.useScopeEnumList)
                })
            }
        })
    }

    /**
     * 查询提交方法
     * @param fieldsValue
     */
    onFinish = () => {
        this.getList()
    }

    /**
     * 添加 方法
     */
    handleAddForm = () => {
        updateMenuModule({
          levelThreeTitle: '数据编码集添加'
        })
        this.props.history.push('/config/codeSet/add');
    }

    /**
     * 查看详情方法
     */
    handleItemDetail = (item) => {
        updateMenuModule({
          levelThreeTitle: '数据编码集详情',
          selectMenuUrl: '/config/codeSet'
        });
        this.props.history.push({pathname: "/config/codeSet/detail", state: {id: item.id}});
    }

    /**
     * 编辑方法
     */
    handleItemEdit = (item) => {
        updateMenuModule({
          levelThreeTitle: '数据编码集编辑',
          selectMenuUrl: '/config/codeSet'
        })
        this.props.history.push({pathname: "/config/codeSet/edit", state: {id: item.id}});
    }

    /**
     * 删除方法
     */
    handleItemDelete = (item) => {
        GetDataCodesetDel(item.id).then(() => {
            if (this.state.codeSetList.length == 1 && this.state.page != 1) {
                this.getList(this.state.page - 1);
            } else {
                this.getList(this.state.page);
            }
        })
    }

    render() {
        return (
            <div className={'codeSet'}>
                <div className={'dataThemeForm'}>
                    <Form
                        layout="inline"
                        className={'codeSetForm'}
                        onFinish={this.onFinish}
                        autoComplete="off"
                        ref={this.formRef}
                        requiredMark={true}
                    >
                        <FormItem
                            name="name"
                            label="名称"
                            rules={[
                                {
                                    whitespace: true,
                                    message: '不能输入空格',
                                }
                            ]}
                        >
                            <Input
                                placeholder="请输名称"
                                style={{borderColor: '#EEEFF7'}}
                            />
                        </FormItem>
                        <FormItem
                            name="createUser"
                            label="&nbsp;&nbsp;&nbsp;&nbsp;创建人"
                            rules={[
                                {
                                    whitespace: true,
                                    message: '不能输入空格',
                                }
                            ]}
                        >
                            <Input
                                placeholder="请输入创建人"
                                style={{borderColor: '#EEEFF7'}}
                            />
                        </FormItem>
                        <FormItem
                            name="useProject"
                            initialValue={this.state.useProject}
                            label="项目"
                            rules={[
                                {
                                    whitespace: true,
                                    message: '不能输入空格',
                                }
                            ]}
                        >
                            <Input
                                placeholder="请输入项目"
                                style={{borderColor: '#EEEFF7'}}
                            />
                        </FormItem>
                        <FormItem
                            name="state"
                            initialValue={this.state.state}
                            label="状态"
                            style={{paddingRight: 0}}
                        >
                            <Select
                                allowClear
                                placeholder="请选择状态"
                            >
                                {
                                    this.state.stateSelectList && this.state.stateSelectList.length != 0 ?
                                        this.state.stateSelectList.map(v => (
                                            <Option value={v.code}
                                                    key={v.code}>{v.name}</Option>
                                        )) : ''
                                }
                            </Select>
                        </FormItem>
                        <FormItem
                            name="type"
                            label="类型"
                            style={{marginBottom: 0}}
                        >
                            <Select
                                allowClear
                                placeholder="请选择类型"
                            >
                                {
                                    this.state.typeSelectList && this.state.typeSelectList.length != 0 ?
                                        this.state.typeSelectList.map(v => (
                                            <Option value={v.code}
                                                    key={v.code}>{v.name}</Option>
                                        )) : ''
                                }
                            </Select>
                        </FormItem>
                        <FormItem
                            name="useScope"
                            label="使用范围"
                            style={{marginBottom: 0}}
                        >
                            <Select
                                allowClear
                                placeholder="请选择使用范围"
                            >
                                {
                                    this.state.useScopeSelectList && this.state.useScopeSelectList.length != 0 ?
                                        this.state.useScopeSelectList.map(v => (
                                            <Option value={v.code}
                                                    key={v.code}>{v.name}</Option>
                                        )) : ''
                                }
                            </Select>
                        </FormItem>
                        <FormItem
                            style={{width: '50%', textAlign: 'right', marginBottom: 0, paddingRight: 0}}
                            wrapperCol={{span: 24}}
                        >
                            <Button
                                className={'searchBtn'}
                                htmlType="submit"
                                style={{borderRadius: '2px', height: 36, marginRight: 16}}
                            >
                                查询
                            </Button>
                            <Button
                                type="primary"
                                onClick={this.handleAddForm}
                                style={{borderRadius: '2px', height: 36}}
                            >
                                添加
                            </Button>
                        </FormItem>
                    </Form>
                </div>
                <div className={'tableListDiv'}>
                    <Table
                        locale={{emptyText: "暂无数据"}}
                        className={'tableList'}
                        bordered
                        columns={this.state.columns}
                        dataSource={this.state.codeSetList}
                        pagination={this.state.pagination}
                        rowKey={'id'}
                        scroll={{x: 1480}}
                        loading={this.state.tableLoading}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
    handleCodesetSelectList(stateSelect, typeSelect, useScopeSelect) {
        const action = actionCreator.codesetSelectListAction(stateSelect, typeSelect, useScopeSelect);
        dispatch(action)
    }
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(codeSet));